export default __webpack_public_path__ + "static/media/2_1_logo.8d05d4cc.png";